export const deliveryModeId = value => {
    if (typeof value === 'number') return value;
    if (/^\d+$/.test(value ?? '')) return Number(value);
    if (value === 'On Campus and Online' || value === 'On Campus & Online') return 3;
    if (value === 'On Campus Only') return 1;
    if (value === 'Online Only') return 2;
    return null;
};

export const onlineNatureId = value => {
    if (typeof value === 'number') return value;
    if (/^\d+$/.test(value ?? '')) return Number(value);
    if (value === '100% Online') return 1;
    if (value === 'Blended') return 2;
    if (value === 'None') return 0;
    return null;
};

export const detailLocations = details =>
    (details?.locations ?? []).map(location => ({
        value: location.locationId,
        label: location.locationName ?? location.locationId,
        statusId: Number(location.statusId ?? 1),
        isNew: false,
    }));
